import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HomepageCacheService {

  private cache = new Map<string, { timestamp: number; observable: Observable<any> }>();
  private ttl = 10 * 60 * 1000; 

  get<T>(payload: Record<string, any>): Observable<T> | undefined {
    const key = this.serializeKey(payload);
    const cached = this.cache.get(key);
    if (!cached) return undefined;
    if (Date.now() - cached.timestamp > this.ttl) {
      this.cache.delete(key);
      return undefined;
    }
    return cached.observable;
  }

  set<T>(payload: Record<string, any>, value: Observable<T>): void {
    const key = this.serializeKey(payload);
    this.cache.set(key, { observable: value, timestamp: Date.now() });
  }

  delete(payload: Record<string, any>): void {
    const key = this.serializeKey(payload);
    this.cache.delete(key);
  }

  clear(): void {
    this.cache.clear();
  }

  serializeKey(payload: Record<string, any>): string {
    return JSON.stringify(
      Object.keys(payload)
        .sort()
        .reduce((acc, key) => {
          acc[key] = payload[key];
          return acc;
        }, {} as any)
    );
  }
}
